import type { FC } from 'react';
import { Card, Flex, Typography } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import type { LocationRowViewModel } from '~/app/landing/operator/service-quality/ServiceQualityPage.types';
import { EvimoTable } from '~/app/components/common/EvimoTable/EvimoTable';

const { Text, Title } = Typography;

export interface LocationsTableCardProps {
  title: string;
  urgentNote: string;
  columns: ColumnsType<LocationRowViewModel>;
  rows: LocationRowViewModel[];
  escalationNote: string;
}

export const LocationsTableCard: FC<LocationsTableCardProps> = ({
  title,
  urgentNote,
  columns,
  rows,
  escalationNote,
}) => {
  return (
    <Card className="om-section-card" styles={{ body: { padding: 24 } }}>
      <Flex vertical gap={16}>
        <Flex justify="space-between" align="center" gap={12} wrap="wrap">
          <Title level={5} className="ds-section-header" style={{ margin: 0 }}>
            {title}
          </Title>
          <Flex align="center" gap={6} className="scorecard-urgent-note">
            <WarningOutlined aria-hidden />
            <Text type="secondary">{urgentNote}</Text>
          </Flex>
        </Flex>

        <EvimoTable
          className="ds-table om-portfolio-table"
          columns={columns}
          dataSource={rows}
          rowKey="id"
          pagination={false}
          size="middle"
        />

        {escalationNote ? (
          <Text type="secondary" className="sq-locations-note">
            {escalationNote}
          </Text>
        ) : null}
      </Flex>
    </Card>
  );
};
